import { createFileRoute } from '@tanstack/react-router'
import { QuoteEmailsPage } from '@/features/quote-builder/emails/quote-emails-page'

export const Route = createFileRoute('/_authenticated/quotes/$quoteId/emails')({
  staticData: { title: 'Quote Emails' },
  component: EmailsRoute,
})

function EmailsRoute() {
  const { quoteId } = Route.useParams()
  return <QuoteEmailsPage quoteId={quoteId} />
}
